module.exports = __webpack_public_path__ + "img/apple-touch-icon.2bc9fcb0.png";